import Populator from './populator.js';

export default class SessionStoragePopulator extends Populator {

    populate() {
        const key = this.input.el.dataset.sessionStorage;
        const value = sessionStorage.getItem(key);            
        if (value) {
            super.populate(value);
        }        
    }

    static applies(input) {
        return input.el.dataset.sessionStorage !== undefined;
    }
}
